import React from "react";
import styles from "./reader.module.css";

export default function LessonLayout({ sidebar, children }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.layout}>
        <aside className={styles.sidebar}>{sidebar}</aside>
        <main className={styles.content}>{children}</main>
      </div>
    </div>
  );
}
